import { defineStore } from "pinia";
import { ref } from "vue";
export const useCurrencyStore = defineStore("currency", () => {
  const selectedCurrency = ref("RUB_RUB");
  function setCurrency(currency) {
    selectedCurrency.value = currency;
  }
  return {
    selectedCurrency,
    setCurrency,
  };
});
